// src/pages/transactions/Edit.jsx
import React, { useState, useEffect, useRef } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import api from '../../core/api';
import '../factors/Factors.css';
import { parseNum } from '../../utils/factorHelpers';
import TransactionForm, { NO_CUSTOMER_METHODS } from './TransactionForm';
import TransactionFormSkeleton from './TransactionFormSkeleton';
const Edit = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);
  const [saving, setSaving] = useState(false);
  const [customer, setCustomer] = useState(null);
  const [form, setForm] = useState({
    direction: 'receive',
    method: 'card',
    date: '',
    amount: '',
    trackingNo: '',
    chequeSerial: '',
    charityName: '',
    description: '',
  });

  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('success');
  const isDirtyRef = useRef(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await api.get(`/transactions/${id}`);
        const t = res.data?.transaction;
        if (!t) {
          if (!cancelled) setNotFound(true);
          return;
        }
        if (cancelled) return;

        setForm({
          direction: t.direction,
          method: t.method,
          date: t.date || '',
          amount: String(Math.round(Number(t.amount) || 0)),
          trackingNo: t.tracking_no || '',
          chequeSerial: t.cheque_serial || '',
          charityName: t.charity_name || '',
          description: t.description || '',
          bankId: String(t.bank_id),
        });
        setCustomer(
          t.customer_id ? { id: t.customer_id, name: t.customer_name || '' } : null
        );
      } catch (err) {
        if (cancelled) return;
        if (err.response?.status === 404) setNotFound(true);
        else {
          setMessage('خطا در دریافت اطلاعات');
          setMessageType('danger');
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [id]);

  useEffect(() => {
    if (!message) return;
    const t = setTimeout(() => setMessage(''), 3000);
    return () => clearTimeout(t);
  }, [message]);

  useEffect(() => {
    const handler = (e) => {
      if (!isDirtyRef.current) return;
      e.preventDefault();
      e.returnValue = '';
    };
    window.addEventListener('beforeunload', handler);
    return () => window.removeEventListener('beforeunload', handler);
  }, []);

  const markDirty = () => {
    isDirtyRef.current = true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const noCustomer = NO_CUSTOMER_METHODS.includes(form.method);

if (!noCustomer && !customer?.id) {
  setMessage('لطفاً یک مشتری انتخاب کنید');
  setMessageType('danger');
  return;
}

    setSaving(true);
    try {
      await api.post(`/transactions/${id}/edit`, {
        direction: form.direction,
        method: form.method,
        date: form.date,
        amount: parseNum(form.amount),
        customerId: noCustomer ? null : customer.id,
        trackingNo: form.trackingNo,
        chequeSerial: form.chequeSerial,
        charityName: form.charityName,
        description: form.description,
        customerId: noCustomer ? null : customer.id,
                        bankId: form.bankId || null,

      });

      isDirtyRef.current = false;
      setMessage('تغییرات ذخیره شد');
      setMessageType('success');
      setTimeout(() => navigate('/dashboard/transactions'), 800);
    } catch (err) {
      setMessage(err.response?.data?.error || 'خطا در ذخیره تغییرات');
      setMessageType('danger');
    } finally {
      setSaving(false);
    }
  };

if (loading) return <TransactionFormSkeleton />;

  if (notFound) {
    return (
      <div className="card">
        <h2>تراکنش یافت نشد</h2>
        <div className="flexend">
          <Link className="btn secondary" to="/dashboard/transactions">
            <i className="fa-solid fa-arrow-right" /> بازگشت به لیست
          </Link>
        </div>
      </div>
    );
  }

  return (
    <>
      {message && (
        <div className={messageType === 'danger' ? 'toast-danger' : 'toast-success'}>
          {message}
        </div>
      )}

      <form onSubmit={handleSubmit}>
        <TransactionForm
          form={form}
          setForm={setForm}
          customer={customer}
          setCustomer={setCustomer}
          onDirty={markDirty}
        />

        <div className="flexend">
          <Link className="btn secondary" to="/dashboard/transactions">
            <i className="fa-solid fa-xmark" /> انصراف
          </Link>
          <button className="btn" type="submit" disabled={saving}>
            {!saving && <i className="fa-solid fa-floppy-disk" />}
            {saving ? 'در حال ذخیره...' : 'ذخیره تغییرات'}
          </button>
        </div>
      </form>
    </>
  );
};

export default Edit;
